import React from "react";
import CommunityBoard from "@/components/CommunityBoard";

export default function Events() {
  return <CommunityBoard kind="event" />;
}
